module.exports = __webpack_public_path__ + "files/e2dab5154257306233fd719cbc7bf47d.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/organization.png
// module id = 705
// module chunks = 27